import { render, staticRenderFns } from "./workOrderType.vue?vue&type=template&id=60713060&scoped=true"
import script from "./workOrderType.vue?vue&type=script&lang=js"
export * from "./workOrderType.vue?vue&type=script&lang=js"
import style0 from "./workOrderType.vue?vue&type=style&index=0&id=60713060&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60713060",
  null
  
)

export default component.exports